export enum FINANCIAL_INFORMATION_FILTER_TYPE {
    QUARTER = 0,
    ANNUAL = 1,
}
